export const TYPE = {
    SIGN_IN: 'SIGN_IN',
    SING_UP: 'SIGN_UP',
    SIGN_OUT: 'SIGN_OUT',
    SET_LOADER: 'SET_LOADER'
}